<template>
  <v-overlay :value="overlay">
    <v-stepper v-model="e1" light>
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1"> 基本設定 </v-stepper-step>

        <v-stepper-step :complete="e1 > 2" step="2">
          スタッフを登録
        </v-stepper-step>

        <v-stepper-step step="3">その他の設定</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-row>
          <v-stepper-content step="1">
            <v-card>
              <v-img src="../../../assets/onboarding-step1.png" width="350" />
              <v-card-text>
                <h1>基本設定</h1>
                <p class="my-2">
                  まずは管理メニューの基本設定からシステムの利用に必要な情報を入力しましょう。<br />
                  運営から発行された初期パスワードの変更や、スタッフに割り当てる等級の設定、役職の設定などが可能です。
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="e1 = 2" color="info">次へ</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card>
              <v-img src="../../../assets/onboarding-step2.png" width="350" />
              <v-card-text>
                <h1>スタッフ設定</h1>
                <p class="my-2">
                  組織のスタッフを登録しましょう。<br />
                  先程のステップで登録した等級や役職を割り当てることができます。<br />
                  登録したログイン情報をスタッフに通知し、Hitonobiの利用を開始しましょう。
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="e1 = 3" color="info">次へ</Button>
                <Button @click="e1 = 1" color="secondary">戻る</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card>
              <v-img
                src="../../../assets/onboarding-aim-setting.png"
                width="350"
              />
              <v-card-text>
                <h1>その他の設定</h1>
                <p class="my-2">
                  人事評価を行う年度の設定、評価基準のための行動、目標設定を行うことができます。<br />
                  操作の不明点については運営までお問い合わせください。<br />
                  それでは以下の完了ボタンを押して、Hitonobiのサービスをはじめましょう。
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="onClick($event)" color="primary">完了</Button>
                <Button @click="e1 = 2" color="secondary">戻る</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-row>
      </v-stepper-items>
    </v-stepper>
  </v-overlay>
</template>

<script>
export default {
  name: 'OnboardingTop',

  props: {
    overlay: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      e1: 1,
      absolute: true,
    };
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
